// extracted by mini-css-extract-plugin
export var desktopOnly = "style-module--desktop-only--8fe10";
export var mobileOnly = "style-module--mobile-only--6ee52";